import { render, staticRenderFns } from "./account-recharge.vue?vue&type=template&id=5c17dc4e&scoped=true&"
import script from "./account-recharge.vue?vue&type=script&lang=js&"
export * from "./account-recharge.vue?vue&type=script&lang=js&"
import style0 from "./account-recharge.vue?vue&type=style&index=0&id=5c17dc4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c17dc4e",
  null
  
)

export default component.exports